import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  Input,
  InputAdornment,
  MenuItem,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  TableSortLabel,
  Divider,
  Pagination,
  PaginationItem,
  Icon,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState, useMemo } from "react";
import Sidebar from "../comman/Sidebar";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import USFlag from "../../images/us-flag.svg";
import {
  ADD_UPDATE_BROKER_URL,
  ADD_UPDATE_LOCATION_URL,
  BROKER_TO_ADMIN_URL,
  GET_PROJECT_DETAILS_BY_ID_URL,
  UPSERT_PROJECT_URL,
} from "../../constants/ApiRoute";
import { authHeader, getLogUserId } from "../comman/MainFunction";
import API from "../comman/API";
import {
  CustomMessage,
  deCryptFun,
  enCryptFun,
} from "../comman/CustomFunction";
import { useFormik } from "formik";
import AddNewLocation from "./AddNewLocation";
import AddEditBroker from "./AddEditBroker";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";

import {
  DASHBOARD_ROUTE,
  PAGE_NOT_FOUND_PATH,
  PROJECTS_ROUTE,
} from "../../constants/RoutePath";
import { pageTypeList } from "../comman/Constant";
import Navbar from "../comman/Navbar";
import CustomPageLoading from "../comman/CustomPageLoading";
import { useDispatch, useSelector } from "react-redux";
import { getAllStatesList } from "../../redux/action";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useToast } from "../comman/CustomMessages";
import dataEmpty from "../../images/data-empty.svg";
import brokerNodata from "../../images/broker-nodata.svg";
import sortupdownarrowIcon from "../../images/sort_up_down_arrow.svg";
import sortuparrowIcon from "../../images/sort_up_arrow.svg";
import sortdownarrowIcon from "../../images/sort_down_arrow.svg";
import RemoveConfirmationProjectBroker from "../model/RemoveConfirmationProjectBroker";
import RemoveConfirmationProjectLocation from "../model/RemoveConfirmationProjectLocation";
import CustomPagination from "../Dashboard/CustomPagination";
import ProjectNTEdetails from "./ProjectNTEdetails";

// customerId: "Customer name",

const initialValues = {
  projectId: 0,
  name: "",
  customerId: "",
  billingPeriod: "",
  mileageRate: "",
  billingDayRate: "",
  perDiem: "",
  billableOfficePerDiem: "",
  billableTravelPerDiem: "",
  principalRate: "",
  projectManagerRate: "",
  fieldAgentRate: "",
  active: true,
  userId: "",
};
const ProjectDetails = () => {
  const [state, setState] = React.useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const navigate = useNavigate();
  const showToast = useToast();
  const [brokerList, setBrokerList] = useState([]);
  console.log(brokerList, "brokerrrrrrListttt");
  const [locationList, setLocationList] = useState([]);
  const [details, setProjectDetails] = useState([]);
  const [NTEDetails, setNTEDetails] = useState([]);
  console.log(details, "detailsdetails");
  const { vertical, horizontal, open } = state;
  const [brokerFlag, setBrokerFlag] = useState(false);
  const [locationFlag, setLocationFlag] = useState(false);
  const [brokerid, setEditBrokerId] = useState();
  const [editFlag, setEditFlag] = useState(true);
  const [saveButtonLoading, setSaveButtonLoading] = useState(false);
  const [pageType, setPageType] = useState("");
  const [locationRowDetail, setLocationRowDetail] = useState("");
  const [brokerRowDetail, setBrokerRowDetail] = useState("");
  const [removeModel, setRemoveModel] = useState(false);
  const [removeModelLocation, setRemoveModelLocation] = useState(false);
  const [removeItem, setRemoveItem] = useState("");
  const pathname = window.location.pathname;
  const parts = pathname.split("/");
  const lastPart = parts[parts.length - 1];
  let id = isNaN(lastPart) ? null : lastPart;
  const [loading, setLoading] = useState(false);
  const [cusName, setCusName] = useState("");
  const [projName, setProjName] = useState("");
  const [isProjectFormUpdated, setIsProjectFormUpdated] = useState(false);
  const dispatch = useDispatch();
  const stateList = deCryptFun(useSelector((s) => s.AllStateListReducer));
  console.log(stateList, "stateListstateList");
  const customerNameList = deCryptFun(
    useSelector((s) => s.AllCustomerListReducer)
  );
  const [page, setPage] = useState(1);
  const [pageBroker, setPagebroker] = useState(1);
  const rowsPerPage = 5;
  console.log(page, "pageeeeeeeeee");
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };
  const handlePageChangeBroker = (event, newPage) => {
    setPagebroker(newPage);
  };
  const [locationOrderBy, setLocationOrderBy] = useState("");
  const [locationOrder, setLocationOrder] = useState("asc");

  const [brokerOrderBy, setBrokerOrderBy] = useState("");
  const [brokerOrder, setBrokerOrder] = useState("asc");

  const handleClick = (newState) => () => {
    setState({ ...newState, open: true });
  };

  const handleClose = () => {
    setState({ ...state, open: false });
  };
  const brokerOpenFun = () => {
    setBrokerFlag(!brokerFlag);
  };
  const brokerOpenFunEdit = (value) => {
    // if (!editFlag) {
    if (value && value.BrokerID) {
      setBrokerRowDetail(value);
      // }
      setBrokerFlag(!brokerFlag);
    }
    // setEditBrokerId(e.currentTarget.dataset.brokerid)
  };
  const brokerClose = (value) => {
    setBrokerFlag(false);
    setBrokerRowDetail("");
    if (value && value.status) {
      showToast(value.message, value.status);
    }
    getprojectDetails();
  };
  const locationOpenFun = (value) => {
    if (value && value.LocationID) {
      setLocationRowDetail(value);
    }
    setLocationFlag(!locationFlag);
  };
  const locatClose = (value) => {
    setLocationFlag(false);
    setLocationRowDetail("");
    if (value && value.status) {
      showToast(value.message, value.status);
    }
    getprojectDetails();
  };
  const action = (
    <React.Fragment>
      <Button color="secondary" size="small" onClick={handleClose}>
        UNDO
      </Button>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
      <Button onClick={handleClick({ vertical: "top", horizontal: "right" })}>
        Top-Right
      </Button>
    </React.Fragment>
  );
  const validationSchema = Yup.object({
    name: Yup.string()
      .trim()
      .required("Project name is required")
      .min(3, "Project name must be at least 3 characters long.")
      .max(100, "Project name cannot exceed 100 characters."),
    customerId: Yup.string().trim().required("Customer name is required"),
    billingPeriod: Yup.number()
      .required("Billing period is required")
      .min(1, "Billing period must be at least 1 day")
      .max(31, "Billing period cannot exceed 31 days")
      .typeError("Billing period is should be number"),
    mileageRate: Yup.number()
      .required("Mileage rate is required")
      .typeError("Mileage rate is should be number"),
    billingDayRate: Yup.number()
      .required("Day rate is required")

      .typeError("Billable day rate is should be number"),
    billableOfficePerDiem: Yup.number()
      .required("Office per diem is required")
      .typeError("Billable office per diem is should be number"),
    billableTravelPerDiem: Yup.number()
      .required("Travel per diem is required")
      .typeError("Billable travel per deam is should be number"),
    principalRate: Yup.number()
      .transform((value, originalValue) =>
        originalValue === "" ? undefined : value
      )
      .typeError("Principal rate is should be number"),
    projectManagerRate: Yup.number()
      .transform((value, originalValue) =>
        originalValue === "" ? undefined : value
      )
      .typeError("Project manager rate is should be number"),
    fieldAgentRate: Yup.number()
      .transform((value, originalValue) =>
        originalValue === "" ? undefined : value
      )
      .typeError("Field agent rate is should be number"),
  });
  const {
    handleSubmit,
    handleChange: formikHandleChange,
    setValues,
    values,
    errors,
    setErrors,
    touched,
    resetForm,
  } = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      updateProject(values);
    },
  });
  const editFun = () => {
    setEditFlag(!editFlag);
    setPageType(pageTypeList[2].edit);
  };

  const brokerRemoveFun = async (value) => {
    let postData = {
      userId: value.UserID,
      projectId: id,
      isRevert: 0,
    };
    const config = {
      method: "POST",
      url: BROKER_TO_ADMIN_URL,
      headers: authHeader(),
      data: {
        webString: enCryptFun(JSON.stringify(postData)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        return null;
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v.message, "error");
      }
    } finally {
    }
  };

  const getprojectDetails = async () => {
    setLoading(true);
    let data = {
      projectId: id,
    };
    const config = {
      method: "GET",
      url: GET_PROJECT_DETAILS_BY_ID_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status == "Success") {
        console.log("stateListrrrrrrrrrrrrrrjjjjjjjjjjjjjjjrrrr", stateList);
        const {
          CustomerID,
          Name,
          BillingPeriod,
          MileageRate,
          BillingDayRate,
          PerDiem,
          Active,
          billableTravelPerDiem,
          UserID,
          BillableOfficePerDiem,
          BillableTravelPerDiem,
          PrincipalRate,
          ProjectManagerRate,
          FieldAgentRate,
        } = parsedResponse.ProjectDetails[0];
        let customername = "";
        let cn =
          customerNameList &&
          JSON.parse(customerNameList).data.filter(
            (r) => parseInt(r.UserId) == parseInt(CustomerID)
          );

        if (cn) {
          customername = cn[0].Name;
        }
        setCusName(customername);
        setProjName(Name);
        setValues({
          ...values,
          customerId: CustomerID,
          name: Name,
          billingPeriod: BillingPeriod,
          mileageRate: !isNaN(parseFloat(MileageRate))
            ? parseFloat(MileageRate).toFixed(3)
            : "0.00",
          billingDayRate: !isNaN(parseFloat(BillingDayRate))
            ? parseFloat(BillingDayRate).toFixed(2)
            : "0.00",
          perDiem: PerDiem,
          billableOfficePerDiem: !isNaN(parseFloat(BillableOfficePerDiem))
            ? parseFloat(BillableOfficePerDiem).toFixed(2)
            : "0.00",
          billableTravelPerDiem: !isNaN(parseFloat(BillableTravelPerDiem))
            ? parseFloat(BillableTravelPerDiem).toFixed(2)
            : "0.00",
          principalRate: !isNaN(
            parseFloat(PrincipalRate ?? parsedResponse.ProjectDetails[0].principalRate)
          )
            ? parseFloat(
                PrincipalRate ?? parsedResponse.ProjectDetails[0].principalRate
              ).toFixed(2)
            : "0.00",
          projectManagerRate: !isNaN(
            parseFloat(
              ProjectManagerRate ??
                parsedResponse.ProjectDetails[0].projectManagerRate
            )
          )
            ? parseFloat(
                ProjectManagerRate ??
                  parsedResponse.ProjectDetails[0].projectManagerRate
              ).toFixed(2)
            : "0.00",
          fieldAgentRate: !isNaN(
            parseFloat(
              FieldAgentRate ?? parsedResponse.ProjectDetails[0].fieldAgentRate
            )
          )
            ? parseFloat(
                FieldAgentRate ?? parsedResponse.ProjectDetails[0].fieldAgentRate
              ).toFixed(2)
            : "0.00",
          active: Active,
          userId: UserID,
        });
        if (
          parsedResponse.BrokerDetails &&
          parsedResponse.BrokerDetails.length > 0
        ) {
          const brokerListArray = parsedResponse.BrokerDetails.filter(
            (rec) => rec.Active == true
          ).map((r) => {
            let StateNameRow =
              stateList &&
              JSON.parse(stateList).data.find((s) => s.countyId == r.State);
            r.Location = `${r.County}, ${
              StateNameRow && StateNameRow.name ? StateNameRow.name : ""
            }`;
            return r;
          });
          console.log(brokerListArray, "brokerListArraybrokerListArray");
          setBrokerList(brokerListArray);
        } else if (
          parsedResponse.BrokerDetails &&
          parsedResponse.BrokerDetails.length == 0
        ) {
          setBrokerList([]);
        }

        if (
          parsedResponse.LocationDetails &&
          parsedResponse.LocationDetails.length > 0
        ) {
          const locationListArray = parsedResponse.LocationDetails.filter(
            (rec) => rec.Active == true
          ).map((r) => {
            let StateNameRow =
              stateList &&
              JSON.parse(stateList).data.find((s) => s.countyId == r.State);
            r.StateName =
              StateNameRow && StateNameRow.name ? StateNameRow.name : "";
            console.log(r, "rrrrrrrrrrrrrrrrrr", StateNameRow);
            console.log(
              parsedResponse.LocationDetails,
              "LocationDetailsrrrrrrrrrrrrrrrrrr"
            );
            console.log("stateListrrrrrrrrrrrrrrrrrr", stateList);
            console.log(
              "stateListrrrrrrfuetetetrrrrrrrrrrrr",
              parsedResponse.LocationDetails.filter((rec) => rec.Active == true)
            );
            return r;
          });

          setLocationList(locationListArray);
        } else if (
          parsedResponse.LocationDetails &&
          parsedResponse.LocationDetails.length == 0
        ) {
          setLocationList([]);
        }
        setProjectDetails(parsedResponse.ProjectDetails);

        const newSort = parsedResponse?.NTEDetails?.sort(
          (a, b) => a?.WarningMeter - b?.WarningMeter
        );
        setNTEDetails(newSort);
      }
      setLoading(false);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v.message, "error");
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      setPageType(pageTypeList[1].list);
      dispatch(getAllStatesList());
      getprojectDetails();
      console.log(stateList, "stateeeeeLsttttttttttt");
    }
  }, [id, stateList]);

  useEffect(() => {
    if (lastPart === "add-project") {
      setEditFlag(false);
      setPageType(pageTypeList[0].add);
    }
  }, [lastPart]);

  const sortedLocationList = useMemo(() => {
    if (locationOrderBy) {
      return [...locationList].sort((a, b) => {
        if (locationOrderBy === "TaxRate") {
          const valueA = a[locationOrderBy];
          const valueB = b[locationOrderBy];

          if (locationOrder === "asc") {
            return valueA - valueB;
          } else {
            return valueB - valueA;
          }
        } else {
          const valueA = a[locationOrderBy].toLowerCase();
          const valueB = b[locationOrderBy].toLowerCase();

          if (locationOrder === "asc") {
            return valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
          } else {
            return valueA > valueB ? -1 : valueA < valueB ? 1 : 0;
          }
        }
      });
    }
    return locationList;
  }, [locationList, locationOrderBy, locationOrder]);
  console.log(
    Math.ceil(sortedLocationList.length / rowsPerPage),
    "Math.ceil(sortedLocationList.length / rowsPerPage)"
  );
  console.log(
    sortedLocationList,
    rowsPerPage,
    "Math.ceil(sortedLocationList.length / rowsPerPage)"
  );

  const sortedBrokerList = useMemo(() => {
    if (brokerOrderBy) {
      return [...brokerList].sort((a, b) => {
        if (
          brokerOrderBy === "Lead" ||
          brokerOrderBy === "PayableTravelPerDiem" ||
          brokerOrderBy === "PayableOfficePerDiem" ||
          brokerOrderBy === "DayRate"
        ) {
          const valueA = a[brokerOrderBy];
          const valueB = b[brokerOrderBy];

          if (brokerOrder === "asc") {
            return valueA - valueB;
          } else {
            return valueB - valueA;
          }
        } else {
          const valueA = a[brokerOrderBy].toLowerCase();
          const valueB = b[brokerOrderBy].toLowerCase();

          if (brokerOrder === "asc") {
            return valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
          } else {
            return valueA > valueB ? -1 : valueA < valueB ? 1 : 0;
          }
        }
      });
    }
    return brokerList;
  }, [brokerList, brokerOrderBy, brokerOrder]);

  //Project Location and Broker List Sort

  // Paginate sorted and filtered data
  const paginatedData = sortedLocationList.slice(
    (page - 1) * rowsPerPage,
    (page - 1) * rowsPerPage + rowsPerPage
  );

  const BokerPaginatedData = sortedBrokerList.slice(
    (pageBroker - 1) * rowsPerPage,
    (pageBroker - 1) * rowsPerPage + rowsPerPage
  );
  console.log(
    BokerPaginatedData,
    "BokerPaginatedDataBokerPaginatedData",
    sortedBrokerList
  );
  const handleLocationSortRequest = (property) => {
    const isAsc = locationOrderBy === property && locationOrder === "asc";
    if (locationOrderBy === property && locationOrder === "desc") {
      setLocationOrder("");
      setLocationOrderBy("");
    } else {
      setLocationOrder(isAsc ? "desc" : "asc");
      setLocationOrderBy(property);
    }
    setPage(1);
  };

  const getLocationSortIcon = (orderByValue) => {
    if (locationOrderBy === orderByValue) {
      return locationOrder === "asc" ? (
        <img src={sortuparrowIcon} className="sort-table-icon-up-down" />
      ) : (
        <img src={sortdownarrowIcon} className="sort-table-icon-up-down" />
      );
    } else {
      return <img src={sortupdownarrowIcon} className="sort-table-icon-both" />;
    }
  };

  const handleBrokerSortRequest = (property) => {
    const isAsc = brokerOrderBy === property && brokerOrder === "asc";
    if (brokerOrderBy === property && brokerOrder === "desc") {
      setBrokerOrder("");
      setBrokerOrderBy("");
    } else {
      setBrokerOrder(isAsc ? "desc" : "asc");
      setBrokerOrderBy(property);
    }
    setPagebroker(1);
    // setSortClickedTime(new Date().toLocaleString());
  };

  const getBrokerSortIcon = (orderByValue) => {
    if (brokerOrderBy === orderByValue) {
      return brokerOrder === "asc" ? (
        <img src={sortuparrowIcon} className="sort-table-icon-up-down" />
      ) : (
        <img src={sortdownarrowIcon} className="sort-table-icon-up-down" />
      );
    } else {
      return <img src={sortupdownarrowIcon} className="sort-table-icon-both" />;
    }
  };

  const updateProject = async (values) => {
    setSaveButtonLoading(true);
    let postData = {
      projectId: id ? id : 0,
      name: values.name,
      billingPeriod: values.billingPeriod ? Number(values.billingPeriod) : 0,
      mileageRate: values.mileageRate ? Number(values.mileageRate) : 0,
      billingDayRate: values.billingDayRate ? Number(values.billingDayRate) : 0,
      perDiem: values.perDiem ? Number(values.perDiem) : 0,
      billableOfficePerDiem: values.billableOfficePerDiem
        ? parseFloat(values.billableOfficePerDiem).toFixed(2)
        : 0.0,
      billableTravelPerDiem: values.billableTravelPerDiem
        ? parseFloat(values.billableTravelPerDiem).toFixed(2)
        : 0.0,
      principalRate: values.principalRate
        ? parseFloat(values.principalRate).toFixed(2)
        : 0.0,
      projectManagerRate: values.projectManagerRate
        ? parseFloat(values.projectManagerRate).toFixed(2)
        : 0.0,
      fieldAgentRate: values.fieldAgentRate
        ? parseFloat(values.fieldAgentRate).toFixed(2)
        : 0.0,
      active: values.active,
      customerId: values.customerId ? values.customerId : 0,
    };

    const config = {
      method: "POST",
      url: UPSERT_PROJECT_URL,
      headers: authHeader(),
      data: {
        webString: enCryptFun(JSON.stringify(postData)),
        flutterString: "",
      },
    };
    setSaveButtonLoading(true);
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        if (pageType === pageTypeList[0].add) {
          showToast(parsedResponse.message, "success");
          navigate("/project-details/" + parsedResponse.ProjectId, {
            id: parsedResponse.ProjectId,
            page: pageTypeList[2].edit,
          });

          setEditFlag(!editFlag);
          resetForm();
        } else {
          showToast(parsedResponse.message, "success");
          setEditFlag(!editFlag);

          getprojectDetails();
        }
        setSaveButtonLoading(false);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v.message, "error");
        setSaveButtonLoading(false);
      }
    } finally {
      // if (pageType === pageTypeList[0].add) {
      //   resetForm();
      // }
      //navigate(PROJECTS_ROUTE);
    }
  };

  const handleDelete = async (value) => {
    // if (!editFlag) {
    setLoading(true);
    let d = {
      brokerId: value.BrokerID,
      userId: value.UserID,
      projectId: id,
      defaultLocationId: value.DefaultLocationID,
      lead: value.Lead,
      isPrincipalRate:
        value.IsPrincipalRate === true ||
        value.IsPrincipalRate === 1 ||
        value.IsPrincipalRate === "1" ||
        value.isPrincipalRate === true ||
        value.isPrincipalRate === 1 ||
        value.isPrincipalRate === "1",
      isProjectManagerRate:
        value.IsProjectManagerRate === true ||
        value.IsProjectManagerRate === 1 ||
        value.IsProjectManagerRate === "1" ||
        value.isProjectManagerRate === true ||
        value.isProjectManagerRate === 1 ||
        value.isProjectManagerRate === "1",
      isFieldAgentRate:
        value.IsFieldAgentRate === true ||
        value.IsFieldAgentRate === 1 ||
        value.IsFieldAgentRate === "1" ||
        value.isFieldAgentRate === true ||
        value.isFieldAgentRate === 1 ||
        value.isFieldAgentRate === "1",
      dayRate: value.DayRate,
      PayablePerDiem: value.PayablePerDiem,
      payableOfficePerDiem: value.PayableOfficePerDiem,
      payableTravelPerDiem: value.PayableTravelPerDiem,
      active: false,
    };

    const config = {
      method: "POST",
      url: ADD_UPDATE_BROKER_URL,
      headers: authHeader(),
      data: {
        webString: enCryptFun(JSON.stringify(d)),
        flutterString: "",
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      console.log(parsedResponse, "ahhhhhhhhhhhhhhh");
      if (parsedResponse.status === "Success") {
        getprojectDetails();
        brokerRemoveFun(value);
        showToast(parsedResponse.message, "success");
        dispatch(getAllStatesList());
        value.Active = false;
        handleDeleteLocation12(r);
        setLoading(false);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v.message, "error");
      }
    } finally {
      setLoading(false);
    }
  };
  const handleDeleteLocation = async (value) => {
    setLoading(true);

    let d = {
      locationId: value.LocationID,
      projectId: value.ProjID,
      county: value.County,
      taxRate: value.TaxRate,
      state: value.State,
      country: value.Country,
      active: false,
    };
    const config = {
      method: "POST",
      url: ADD_UPDATE_LOCATION_URL,
      headers: authHeader(),
      data: {
        webString: enCryptFun(JSON.stringify(d)),
        flutterString: "",
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        value.Active = false;
        showToast(parsedResponse.message, "success");
        getprojectDetails();
        handleDelete12(r);
        setLoading(false);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v.message, "error");
        setLoading(false);
      }
    } finally {
    }
  };

  const removeItemFuncConfirm = (value) => {
    if (value && value.remove_type) {
      setRemoveModel(false);

      if (value.remove_type == "project_broker") {
        handleDelete(value.data);
      }
    } else {
      setRemoveModel(false);
    }
  };

  const removeItemLocationFuncConfirm = (value) => {
    if (value && value.remove_type) {
      setRemoveModelLocation(false);

      if (value.remove_type == "project_location") {
        handleDeleteLocation(value.data);
      }
    } else {
      setRemoveModelLocation(false);
    }
  };

  useEffect(() => {
    dispatch(getAllStatesList());
  }, []);
  const handlecancel = () => {
    if (pageType == pageTypeList[2].edit) {
      getprojectDetails();
    }
    setEditFlag(!editFlag);
  };
  const handleChangeCustomer = (e) => {
    // id=""
    // getprojectDetails()
    setBrokerList([]);
    setLocationList([]);
    setIsProjectFormUpdated(true);
    //setValues({ ...initialValues, customerId: e.target.value });
    setValues({ ...values, customerId: e.target.value });
  };

  const handleChangeProjectName = (event) => {
    const { name, value } = event.target;
    // setIsProjectFormUpdated(true);
    var trimmedValue = "";

    if (value.startsWith(" ")) {
      trimmedValue = value.trimStart();
    } else {
      trimmedValue = value;
    }

    if (trimmedValue.length <= 100) {
      setValues({ ...values, [name]: trimmedValue });
    }
  };

  const handleChangeBillingPeriods = (event) => {
    const { name, value } = event.target;
    // setIsProjectFormUpdated(true);
    const intValue = value.replace(/[^\d]/g, "");
    const sanitizedValue =
      intValue === "" ? "" : Math.min(parseInt(intValue), 31).toString();

    // Ensure that the sanitized value is not "0"
    const finalValue = sanitizedValue === "0" ? "" : sanitizedValue;

    setValues({ ...values, [name]: finalValue });
  };

  const handleChangeDecimalValue = (event) => {
    const { name, value } = event.target;
    const sanitizedValue = value.replace(/[^\d.]/g, "");
    if ((sanitizedValue.match(/\./g) || []).length > 1) {
      return;
    }

    if (/^0[0-9]+/.test(sanitizedValue)) {
      const correctedValue = sanitizedValue.replace(/^0+/, "");
      setValues({ ...values, [name]: correctedValue });
      return;
    }

    const decimalParts = sanitizedValue.split(".");
    if (decimalParts[1] && decimalParts[1].length > 2) {
      return;
    }

    setValues({ ...values, [name]: sanitizedValue });
  };

  const handleChangeMileageRateValue = (event) => {
    const { name, value } = event.target;
    const sanitizedValue = value.replace(/[^\d.]/g, "");
    if ((sanitizedValue.match(/\./g) || []).length > 1) {
      return;
    }

    if (/^0[0-9]+/.test(sanitizedValue)) {
      const correctedValue = sanitizedValue.replace(/^0+/, "");
      setValues({ ...values, [name]: correctedValue });
      return;
    }

    const decimalParts = sanitizedValue.split(".");
    if (decimalParts[1] && decimalParts[1].length > 3) {
      return;
    }

    setValues({ ...values, [name]: sanitizedValue });
  };

  const handleChange = (e) => {
    setIsProjectFormUpdated(true);
    formikHandleChange(e);
  };

  const valuer = localStorage.getItem("DASHBOARD_NAVI");

  useEffect(() => {
    const handlePopState = () => {
      // Perform any custom logic if needed
      console.log("Browser back button clicked");
    };

    // Attach the popstate event listener
    window.addEventListener("popstate", handlePopState);

    return () => {
      // Clean up the event listener on unmount
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  useEffect(() => {
    if (paginatedData.length === 0 && page > 1) {
      setPage(page - 1);
    }
  }, [paginatedData, page]);

  const handleDelete12 = (itemToDelete) => {
    const updatedLocationList = locationList.filter(
      (item) => item.id !== itemToDelete.id
    );

    const totalPages = Math.ceil(updatedLocationList.length / rowsPerPage);
    const newPage = page > totalPages ? totalPages : page;

    setLocationList(updatedLocationList);
    if (page !== newPage) {
      setPage(newPage);
    }
  };
  const handleDeleteLocation12 = (itemToDelete) => {
    const updatedLocationList = brokerList.filter(
      (item) => item.id !== itemToDelete.id
    );

    const totalPages = Math.ceil(updatedLocationList.length / rowsPerPage);
    const newPage = pageBroker > totalPages ? totalPages : pageBroker;

    setLocationList(updatedLocationList);
    if (pageBroker !== newPage) {
      setPagebroker(newPage);
    }
  };

  useEffect(() => {
    if (BokerPaginatedData.length === 0 && pageBroker > 1) {
      setPagebroker(pageBroker - 1);
    }
  }, [BokerPaginatedData, pageBroker]);

  // useEffect(() => {
  //   // Check if bid is a number and has more than 3 digits
  //   if (!(/^\d*$/).test(id)) {
  //     // If bid is invalid (e.g., less than 4 digits), redirect to the dashboard
  //     navigate(PAGE_NOT_FOUND_PATH, { replace: true });
  //   }
  // }, [id, navigate]);

  return (
    <>
      {loading && <CustomPageLoading />}
      <Box sx={{ display: "-webkit-box" }}>
        <Sidebar higlightSide={"2"} />
        {/* <Box component="main" sx={{ flexGrow: 1, p: 3 }}> */}

        <Box component="main" sx={{ flexGrow: 1, p: "18px 20px" }}>
          <Navbar
            title={
              pageType === pageTypeList[2].edit ||
              //   `${projName}|${cusName}`
              // ) : // pageType === pageTypeList[2].edit
              //   ? ${values.name}|${cusName}
              //   : pageType === pageTypeList[1].list
              //   ? ${values.name}<span>|</span>${cusName}
              //   : "Add Project"
              pageType === pageTypeList[1].list ? (
                <>
                  <Stack direction="row" spacing={1.7} alignItems="center">
                    <div style={{ lineBreak: "anywhere" }}>
                      <span className="nav-title">Project Name</span>
                      {projName}
                    </div>
                    {/* <span style={{ color: "#C8C8C8" }}>|</span> */}
                    <Divider orientation="vertical" variant="middle" flexItem />
                    <div style={{ lineBreak: "anywhere" }}>
                      <span className="nav-title">Customer Name</span>
                      {cusName}
                    </div>
                  </Stack>
                </>
              ) : (
                "Add Project"
              )
            }
            backFlag={true}
            backRoute={valuer ? DASHBOARD_ROUTE : PROJECTS_ROUTE}
          />
          <Box className="bg-box user-log">
            <Stack
              sx={{ mb: 2 }}
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography
                sx={{ mb: "0px !important" }}
                className="customer-title"
              >
                Project Details
              </Typography>

              <Stack direction="row" spacing={1} justifyContent="flex-end">
                {editFlag == true ? (
                  <Button
                    className="edit-btn"
                    variant="outlined"
                    startIcon={
                      <span className="material-symbols-outlined">Edit</span>
                    }
                    type="submit"
                    onClick={editFun}
                  >
                    Edit
                  </Button>
                ) : (
                  <>
                    <Button
                      className={
                        saveButtonLoading ? "disable-filter-btn" : "primary-btn"
                      }
                      variant="outlined"
                      type="submit"
                      color="success"
                      onClick={handleSubmit}
                      disabled={saveButtonLoading}
                    >
                      {saveButtonLoading && (
                        <CircularProgress
                          color={"inherit"}
                          size={10}
                          sx={{ marginRight: "3px" }}
                        />
                      )}
                      Save
                    </Button>
                  </>
                )}
                {!editFlag && pageType != pageTypeList[0].add && (
                  //    {pageType === pageTypeList[2].edit
                  // ||
                  //  pageType === pageTypeList[1].list
                  // ?
                  <Button
                    className="cancel-btn"
                    variant="contained"
                    type="submit"
                    onClick={handlecancel}
                    // disabled={!editFlag}
                  >
                    Cancel
                  </Button>
                )}

                {/* {isProjectFormUpdated && pageType == pageTypeList[0].add && ( */}
                {pageType == pageTypeList[0].add && (
                  //    {pageType === pageTypeList[2].edit
                  // ||
                  //  pageType === pageTypeList[1].list
                  // ?
                  <Button
                    className="cancel-btn"
                    variant="contained"
                    onClick={() => {
                      setIsProjectFormUpdated(false);
                      localStorage.setItem(
                        "PROJECT_PAGE_BACKBUTTON_CLICK",
                        true
                      );
                      resetForm();
                      navigate(PROJECTS_ROUTE);
                    }}
                  >
                    Cancel
                  </Button>
                )}
              </Stack>
            </Stack>
            <Box className="user-details-form">
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={{ xs: 2, sm: 4, md: 7 }}
                alignItems="center"
                sx={{ width: "100%" }}
              >
                <FormControl variant="standard" sx={{ flex: 1, width: "100%" }}>
                  <p className="label">Customer Name:</p>
                  <Select
                    className="select-field"
                    sx={{
                      p: 0,
                      ".MuiSelect-select": {
                        color:
                          values.customerId === ""
                            ? "#898989 !important"
                            : "#212121 !important",
                      },
                      pr: "25px !important",
                    }}
                    name="customerId"
                    displayEmpty
                    // placeholder="Select Customer"
                    value={values.customerId || ""}
                    onChange={handleChangeCustomer}
                    disabled={editFlag || pageType == "edit"}
                    label="Select customer"
                    IconComponent={KeyboardArrowDownIcon}
                    error={errors.customerId && touched.customerId}
                    helperText={
                      errors.customerId && touched.customerId
                        ? errors.customerId
                        : ""
                    }
                  >
                    <MenuItem disabled value="">
                      Select Customer
                    </MenuItem>
                    {/* {customerNameList &&
  JSON.parse(customerNameList).data
    .sort((a, b) => {
      const nameA = a.Name;
      const nameB = b.Name;

      // Check if either name starts with uppercase vs lowercase
      if (nameA[0] === nameA[0].toUpperCase() && nameB[0] !== nameB[0].toUpperCase()) {
        return -1; // `nameA` comes first
      }
      if (nameA[0] !== nameA[0].toUpperCase() && nameB[0] === nameB[0].toUpperCase()) {
        return 1; // `nameB` comes first
      }

      // Fallback to localeCompare for alphabetical sorting
      return nameA.localeCompare(nameB);
    })
    .map((item) => (
      <MenuItem key={item.UserId} value={item.UserId}>
        <span className="billing-select-option">
          {item.Name}
        </span>
      </MenuItem>
    ))} */}
                    {(() => {
                      try {
                        const data = JSON.parse(customerNameList)?.data || [];
                        return data
                          .filter((item) => item?.UserId && item?.Name)
                          .sort((a, b) => {
                            const nameA = a.Name;
                            const nameB = b.Name;
                            const firstCharA = nameA[0].toLowerCase();
                            const firstCharB = nameB[0].toLowerCase();

                            if (firstCharA !== firstCharB)
                              return firstCharA.localeCompare(firstCharB);
                            const isUpperCaseA =
                              nameA[0] === nameA[0].toUpperCase();
                            const isUpperCaseB =
                              nameB[0] === nameB[0].toUpperCase();
                            if (isUpperCaseA !== isUpperCaseB)
                              return isUpperCaseA ? -1 : 1;
                            return nameA.localeCompare(nameB);
                          })
                          .map((item) => (
                            <MenuItem key={item.UserId} value={item.UserId}>
                              <span className="billing-select-option">
                                {item.Name}
                              </span>
                            </MenuItem>
                          ));
                      } catch (error) {
                        console.error("Error parsing customerNameList:", error);
                        return null;
                      }
                    })()}
                  </Select>
                  <FormHelperText error={true}>
                    {errors.customerId && touched.customerId
                      ? errors.customerId
                      : ""}
                  </FormHelperText>
                </FormControl>
                <FormControl variant="standard" sx={{ flex: 1, width: "100%" }}>
                  <p className="label">Project Name:</p>
                  <Input
                    name="name"
                    id="name"
                    value={values.name}
                    placeholder="Enter Project Name"
                    onChange={handleChangeProjectName}
                    disabled={editFlag}
                    error={errors.name && touched.name}
                    helperText={errors.name && touched.name ? errors.name : ""}
                  />
                  <FormHelperText error={true}>
                    {errors.name && touched.name ? errors.name : ""}
                  </FormHelperText>
                </FormControl>
              
                <FormControl variant="standard" sx={{ flex: 1, width: "100%" }}>
                  <p className="label">Billing Period (in days):</p>
                  <Input
                    name="billingPeriod"
                    id="billingPeriod"
                    value={values.billingPeriod}
                    placeholder="Enter Billing Period"
                    onChange={handleChangeBillingPeriods}
                    disabled={editFlag}
                    error={errors.billingPeriod && touched.billingPeriod}
                    helperText={
                      errors.billingPeriod && touched.billingPeriod
                        ? errors.billingPeriod
                        : ""
                    }
                  />
                
                  <FormHelperText error={true}>
                    {errors.billingPeriod && touched.billingPeriod
                      ? errors.billingPeriod
                      : ""}
                  </FormHelperText>
                </FormControl>
                </Stack>
                 {/* Row 2 */}
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={{ xs: 2, sm: 4, md: 7 }}
                  alignItems="center"
                  sx={{ width: "100%" }}
                >
                <FormControl variant="standard" sx={{ flex: 1, width: "100%" }}>
                  <p className="label">Billable Day Rate:</p>
                  <Input
                    className="dollar-field"
                    name="billingDayRate"
                    id="billingDayRate"
                    value={values.billingDayRate}
                    placeholder="Enter Billable Day Rate"
                    onChange={handleChangeDecimalValue}
                    disabled={editFlag}
                    error={errors.billingDayRate && touched.billingDayRate}
                    helperText={
                      errors.billingDayRate && touched.billingDayRate
                        ? errors.billingDayRate
                        : ""
                    }
                    startAdornment={
                      <InputAdornment position="start">
                        <span className="dollar-icon">$</span>
                      </InputAdornment>
                    }
                  />
                  <FormHelperText error={true}>
                    {errors.billingDayRate && touched.billingDayRate
                      ? errors.billingDayRate
                      : ""}
                  </FormHelperText>
                </FormControl>

                <FormControl variant="standard" sx={{ flex: 1, width: "100%" }}>
                  <p className="label">
                    Billable Office Per Diem:{" "}
                    <Tooltip
                      title="Used in the invoice when the billing statement value is
                        missing or 0."
                      placement="top"
                    >
                      <span
                        style={{
                          fontSize: "16px",
                          cursor: "pointer",
                          position: "absolute",
                          color: "#898989",
                          marginLeft: "5px",
                        }}
                        className="material-symbols-outlined"
                      >
                        help
                      </span>
                    </Tooltip>
                  </p>
                  <Input
                    className="dollar-field"
                    name="billableOfficePerDiem"
                    id="billableOfficePerDiem"
                    value={values.billableOfficePerDiem}
                    disabled={editFlag}
                    placeholder="Enter Billable Office Per Diem"
                    onChange={handleChangeDecimalValue}
                    error={
                      errors.billableOfficePerDiem &&
                      touched.billableOfficePerDiem
                    }
                    helperText={
                      errors.billableOfficePerDiem &&
                      touched.billableOfficePerDiem
                        ? errors.billableOfficePerDiem
                        : ""
                    }
                    startAdornment={
                      <InputAdornment position="start">
                        <span className="dollar-icon">$</span>
                      </InputAdornment>
                    }
                  />
                  <FormHelperText error={true}>
                    {errors.billableOfficePerDiem &&
                    touched.billableOfficePerDiem
                      ? errors.billableOfficePerDiem
                    : ""}
                  </FormHelperText>
                </FormControl>
                <FormControl variant="standard" sx={{ flex: 1, width: "100%" }}>
                  <p className="label">Billable Travel Per Diem:</p>
                  <Input
                    className="dollar-field"
                    name="billableTravelPerDiem"
                    id="billableTravelPerDiem"
                    value={values.billableTravelPerDiem}
                    placeholder="Enter Billable Travel Per Diem"
                    onChange={handleChangeDecimalValue}
                    disabled={editFlag}
                    error={
                      errors.billableTravelPerDiem &&
                      touched.billableTravelPerDiem
                    }
                    helperText={
                      errors.billableTravelPerDiem &&
                      touched.billableTravelPerDiem
                        ? errors.billableTravelPerDiem
                        : ""
                    }
                    startAdornment={
                      <InputAdornment position="start">
                        <span className="dollar-icon">$</span>
                      </InputAdornment>
                    }
                  />
                  <FormHelperText error={true}>
                    {errors.billableTravelPerDiem &&
                    touched.billableTravelPerDiem
                      ? errors.billableTravelPerDiem
                      : ""}
                  </FormHelperText>
                </FormControl>
              </Stack>
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={{ xs: 2, sm: 4, md: 7 }}
                alignItems="center"
                sx={{ width: "100%" }}
              >
                {[
                  ["principalRate", "Principal Rate"],
                  ["projectManagerRate", "Project Manager Rate"],
                  ["fieldAgentRate", "Field Agent Rate"],
                ].map(([name, label]) => (
                  <FormControl variant="standard" key={name} sx={{ flex: 1, width: "100%" }}>
                    <p className="label">{label}:</p>
                    <Input
                      className="dollar-field"
                      name={name}
                      id={name}
                      value={values[name]}
                      placeholder={`Enter ${label}`}
                      onChange={handleChangeDecimalValue}
                      disabled={editFlag}
                      error={errors[name] && touched[name]}
                      startAdornment={
                        <InputAdornment position="start">
                          <span className="dollar-icon">$</span>
                        </InputAdornment>
                      }
                    />
                    <FormHelperText error={true}>
                      {errors[name] && touched[name] ? errors[name] : ""}
                    </FormHelperText>
                  </FormControl>
                ))}
              </Stack>
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={{ xs: 2, sm: 4, md: 7 }}
                alignItems="center"
                sx={{ width: "100%" }}
              >
                <FormControl variant="standard" sx={{ flex: 1, width: "100%" }}>
                  <p className="label">Mileage Rate:</p>
                  <Input
                    className="dollar-field"
                    name="mileageRate"
                    id="mileageRate"
                    value={values.mileageRate}
                    disabled={editFlag}
                    placeholder="Enter Mileage Rate"
                    onChange={handleChangeMileageRateValue}
                    error={errors.mileageRate && touched.mileageRate}
                    helperText={
                      errors.mileageRate && touched.mileageRate
                        ? errors.mileageRate
                        : ""
                    }
                    startAdornment={
                      <InputAdornment position="start">
                        <span className="dollar-icon">$</span>
                      </InputAdornment>
                    }
                  />
                  <FormHelperText error={true}>
                    {errors.mileageRate && touched.mileageRate
                      ? errors.mileageRate
                      : ""}
                  </FormHelperText>
                </FormControl>
                <Box sx={{ flex: 1, width: "100%" }}>
                  <p className="label">Status:</p>
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="flex-start"
                    spacing={2}
                  >
                    <FormControlLabel
                      className="checkbox"
                      control={
                        <Checkbox
                          name="active"
                          id="activeYes"
                          disabled={editFlag}
                          onChange={() =>
                            setValues({ ...values, active: true })
                          }
                          //onChange={handleChange}
                          sx={{ color: "gray" }}
                          checked={values.active == true}
                        />
                      }
                      label="Active"
                    />

                    <FormControlLabel
                      className="checkbox"
                      control={
                        <Checkbox
                          name="active"
                          id="activeNo"
                          disabled={editFlag}
                          onChange={() => {
                            setIsProjectFormUpdated(true);
                            setValues({ ...values, active: false });
                          }}
                          sx={{ color: "gray" }}
                          checked={values.active == false}
                        />
                      }
                      label="Inactive"
                    />
                    {/* Empty third column */}
                  </Stack>
                </Box>
                <Box sx={{ flex: 1, width: "100%" }} />
              </Stack>
            </Box>
          </Box>
          <Box sx={{ mt: "12px" }} className="bg-box">
            <Stack
              sx={{ mb: 2 }}
              direction={{ xs: "column", sm: "row", md: "row" }}
              alignItems={{ xs: "baseline", sm: "center", md: "center" }}
              justifyContent="space-between"
            >
              <Typography
                sx={{ mb: "0 !important" }}
                className="customer-title"
              >
                Project Locations
              </Typography>
              <Button
                sx={{ mt: { xs: "10px", sm: "0px" } }}
                startIcon={
                  <span className="material-symbols-outlined">add</span>
                }
                className={!id ? "default-btn" : "primary-btn"}
                variant="contained"
                color="success"
                disabled={!id}
                onClick={() => locationOpenFun()}
              >
                New Location
              </Button>
            </Stack>
            <TableContainer
              className="project-broker-table"
              sx={{ boxShadow: "none" }}
              component={Paper}
            >
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ minWidth: { xs: "100px", md: "200px" } }}>
                      Country
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={locationOrderBy === "StateName"}
                        direction={
                          locationOrderBy === "StateName"
                            ? locationOrder
                            : "asc"
                        }
                        onClick={() => handleLocationSortRequest("StateName")}
                        IconComponent={() => getLocationSortIcon("StateName")}
                        style={
                          locationOrderBy === "StateName"
                            ? { color: "#007fff" }
                            : {}
                        }
                      >
                        State
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={locationOrderBy === "County"}
                        direction={
                          locationOrderBy === "County" ? locationOrder : "asc"
                        }
                        onClick={() => handleLocationSortRequest("County")}
                        IconComponent={() => getLocationSortIcon("County")}
                        style={
                          locationOrderBy === "County"
                            ? { color: "#007fff" }
                            : {}
                        }
                      >
                        County
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={locationOrderBy === "TaxRate"}
                        direction={
                          locationOrderBy === "TaxRate" ? locationOrder : "asc"
                        }
                        onClick={() => handleLocationSortRequest("TaxRate")}
                        IconComponent={() => getLocationSortIcon("TaxRate")}
                        style={
                          locationOrderBy === "TaxRate"
                            ? { color: "#007fff" }
                            : {}
                        }
                      >
                        Day Rate
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedData &&
                    paginatedData.map((r) => {
                      const { County, StateName, TaxRate } = r;
                      return (
                        <TableRow key={r.id}>
                          <TableCell scope="row">
                            <Stack direction="row" spacing={1.2}>
                              <img
                                style={{ height: "18.356px" }}
                                src={USFlag}
                                alt="US Flag"
                              />
                              <Typography className="flag-title">
                                United States of America
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell>{StateName}</TableCell>
                          <TableCell>{County}</TableCell>
                          <TableCell>${TaxRate?.toFixed(2)}</TableCell>
                          <TableCell>
                            <Stack direction="row" spacing={1}>
                              {/* HOS-520  - Remove Project location, dont change this line */}
                              {/* <span
                                className="active-icon"
                                onClick={() => locationOpenFun(r)}
                                style={{ cursor: "pointer" }}
                              >
                                <span className="material-symbols-outlined">
                                  edit
                                </span>
                              </span> */}
                              <span
                                className="delete-icon"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  setRemoveItem({
                                    remove_type: "project_location",
                                    data: r,
                                  });
                                  setRemoveModelLocation(true);
                                }}
                              >
                                <span className="material-symbols-outlined">
                                  delete
                                </span>
                              </span>
                            </Stack>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
              {sortedLocationList.length === 0 && (
                <Box sx={{ textAlign: "center" }}>
                  <img src={dataEmpty} alt="No Data" />
                </Box>
              )}
            </TableContainer>
            {paginatedData?.length > 0 && (
              <Pagination
                // variant="outlined"
                shape="rounded"
                count={Math.ceil(sortedLocationList.length / rowsPerPage)}
                page={page}
                renderItem={(item) => (
                  <PaginationItem
                    components={{
                      previous: () => (
                        <Icon className="material-symbols-outlined">
                          keyboard_backspace
                        </Icon>
                      ),
                      next: () => (
                        <Icon className="material-symbols-outlined">east</Icon>
                      ),
                    }}
                    {...item}
                  />
                )}
                onChange={handlePageChange}
                sx={{ mt: "13.5px", display: "flex", justifyContent: "end" }}
                // sx={{ mt: "13.5px", display: "flex", justifyContent: "center" }}
              />
            )}
          </Box>
          <Box sx={{ mt: "12px" }} className="bg-box">
            <Stack
              sx={{ mb: 2 }}
              direction={{ xs: "column", sm: "row", md: "row" }}
              alignItems={{ xs: "baseline", sm: "center", md: "center" }}
              justifyContent="space-between"
            >
              <Typography
                sx={{ marginBottom: "0px !important" }}
                className="customer-title"
              >
                Project Brokers
              </Typography>

              <Button
                sx={{ mt: { xs: "-10px" } }}
                startIcon={<span class="material-symbols-outlined">add</span>}
                className={
                  locationList && locationList.length == 0
                    ? "default-btn"
                    : "primary-btn"
                }
                variant="contained"
                color="success"
                onClick={brokerOpenFun}
                disabled={locationList && locationList.length == 0}
              >
                New Broker
              </Button>
            </Stack>
            <TableContainer
              className="project-broker-table"
              sx={{ boxShadow: "none" }}
              component={Paper}
            >
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ minWidth: { xs: "100px", md: "200px" } }}>
                      <TableSortLabel
                        active={locationOrderBy === "FirstName"}
                        direction={
                          locationOrderBy === "FirstName"
                            ? locationOrder
                            : "asc"
                        }
                        onClick={() => handleBrokerSortRequest("FirstName")}
                        IconComponent={() => getBrokerSortIcon("FirstName")}
                        style={
                          brokerOrderBy === "FirstName"
                            ? { color: "#007fff" }
                            : {}
                        }
                      >
                        Broker
                      </TableSortLabel>
                    </TableCell>

                    <TableCell>
                      <TableSortLabel
                        active={locationOrderBy === "DayRate"}
                        direction={
                          locationOrderBy === "DayRate" ? locationOrder : "asc"
                        }
                        onClick={() => handleBrokerSortRequest("DayRate")}
                        IconComponent={() => getBrokerSortIcon("DayRate")}
                        style={
                          brokerOrderBy === "DayRate"
                            ? { color: "#007fff" }
                            : {}
                        }
                      >
                        Payable Day Rate
                      </TableSortLabel>
                    </TableCell>

                    <TableCell>
                      <TableSortLabel
                        active={locationOrderBy === "PayableOfficePerDiem"}
                        direction={
                          locationOrderBy === "PayableOfficePerDiem"
                            ? locationOrder
                            : "asc"
                        }
                        onClick={() =>
                          handleBrokerSortRequest("PayableOfficePerDiem")
                        }
                        IconComponent={() =>
                          getBrokerSortIcon("PayableOfficePerDiem")
                        }
                        style={
                          brokerOrderBy === "PayableOfficePerDiem"
                            ? { color: "#007fff" }
                            : {}
                        }
                      >
                        Payable Office Per Diem
                      </TableSortLabel>
                    </TableCell>

                    <TableCell>
                      <TableSortLabel
                        active={locationOrderBy === "PayableTravelPerDiem"}
                        direction={
                          locationOrderBy === "PayableTravelPerDiem"
                            ? locationOrder
                            : "asc"
                        }
                        onClick={() =>
                          handleBrokerSortRequest("PayableTravelPerDiem")
                        }
                        IconComponent={() =>
                          getBrokerSortIcon("PayableTravelPerDiem")
                        }
                        style={
                          brokerOrderBy === "PayableTravelPerDiem"
                            ? { color: "#007fff" }
                            : {}
                        }
                      >
                        Payable Travel Per Diem
                      </TableSortLabel>
                    </TableCell>

                    <TableCell>
                      <TableSortLabel
                        active={locationOrderBy === "Location"}
                        direction={
                          locationOrderBy === "Location" ? locationOrder : "asc"
                        }
                        onClick={() => handleBrokerSortRequest("Location")}
                        IconComponent={() => getBrokerSortIcon("Location")}
                        style={
                          brokerOrderBy === "Location"
                            ? { color: "#007fff" }
                            : {}
                        }
                      >
                        Location
                      </TableSortLabel>
                    </TableCell>

                    <TableCell>
                      <TableSortLabel
                        active={locationOrderBy === "Lead"}
                        direction={
                          locationOrderBy === "Lead" ? locationOrder : "asc"
                        }
                        onClick={() => handleBrokerSortRequest("Lead")}
                        IconComponent={() => getBrokerSortIcon("Lead")}
                        style={
                          brokerOrderBy === "Lead" ? { color: "#007fff" } : {}
                        }
                      >
                        Lead
                      </TableSortLabel>
                    </TableCell>

                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {BokerPaginatedData &&
                    BokerPaginatedData.map((rec, i) => {
                      const {
                        BrokerID,
                        BrokerName,
                        FirstName,
                        LastName,
                        Lead,
                        DayRate = 0,
                        County,
                        Location,
                        PayablePerDiem = 0,
                        PayableTravelPerDiem = 0,
                        PayableOfficePerDiem = 0,
                        Active,
                        userActiveStatus,
                        UserRoleId,
                      } = rec;
                      return (
                        <TableRow
                          key={`broker_${i}`}
                          style={
                            userActiveStatus == 0 ||
                            !UserRoleId.split(",").includes(
                              "6d8f5f3c-8ed1-40d5-b870-d54283c7da28"
                            )
                              ? { backgroundColor: "#f6f6f6" }
                              : {}
                          }
                        >
                          <TableCell sx={{ lineBreak: "anywhere" }} scope="row">
                            {`${FirstName} ${LastName}`}
                          </TableCell>
                          <TableCell>${DayRate?.toFixed(2)}</TableCell>
                          <TableCell>
                            $
                            {!isNaN(parseFloat(PayableOfficePerDiem))
                              ? parseFloat(PayableOfficePerDiem).toFixed(2)
                              : "0.00"}
                          </TableCell>
                          <TableCell>
                            $
                            {!isNaN(parseFloat(PayableTravelPerDiem))
                              ? parseFloat(PayableTravelPerDiem).toFixed(2)
                              : "0.00"}
                          </TableCell>

                          <TableCell>{Location}</TableCell>
                          <TableCell>
                            <Box sx={{ width: "100%", minWidth: "59px" }}>
                              <span
                                className={
                                  Lead == 1 ? "active-btn" : "inactive-btn"
                                }
                              >
                                {Lead == 1 ? "Yes" : "No"}
                              </span>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Stack direction="row" spacing={1}>
                              <span
                                className={"active-icon"}
                                style={{ cursor: "pointer" }}
                                onClick={() => brokerOpenFunEdit(rec)}
                                data-brokerid={BrokerID}
                              >
                                <span className="material-symbols-outlined">
                                  edit
                                </span>
                              </span>
                              <span
                                className={"delete-icon"}
                                style={{ cursor: "pointer" }}
                                data-brokerid={BrokerID}
                                onClick={() => {
                                  setRemoveItem({
                                    remove_type: "project_broker",
                                    data: rec,
                                  });
                                  setRemoveModel(true);
                                }}
                              >
                                <span className="material-symbols-outlined">
                                  delete
                                </span>
                              </span>
                            </Stack>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>

              {BokerPaginatedData &&
              BokerPaginatedData.filter((rec) => rec.Active == true).length >
                0 ? null : (
                <Box sx={{ textAlign: "center" }}>
                  <img src={brokerNodata} />
                </Box>
              )}
              <br />
              {/* {!loading && total > 0 && (
                    <Pagination
                      variant="outlined"
                      shape="rounded"
                      count={total}
                      page={page}
                      onChange={handlePageChange}
                    />
                  )} */}
            </TableContainer>
            {BokerPaginatedData?.length > 0 && (
              <Pagination
                // variant="outlined"
                shape="rounded"
                count={Math.ceil(sortedBrokerList.length / rowsPerPage)}
                page={pageBroker}
                renderItem={(item) => (
                  <PaginationItem
                    components={{
                      previous: () => (
                        <Icon className="material-symbols-outlined">
                          keyboard_backspace
                        </Icon>
                      ),
                      next: () => (
                        <Icon className="material-symbols-outlined">east</Icon>
                      ),
                    }}
                    {...item}
                  />
                )}
                onChange={handlePageChangeBroker}
                sx={{ mt: "13.5px", display: "flex", justifyContent: "end" }}
                // sx={{ mt: "13.5px", display: "flex", justifyContent: "center" }}
              />
            )}
          </Box>
          <ProjectNTEdetails
            projectDetails={details}
            setProjectDetails={setProjectDetails}
            getprojectDetails={getprojectDetails}
            NTEDetails={NTEDetails}
            setNTEDetails={setNTEDetails}
            locationList={id}
            setLoading={setLoading}
          />
        </Box>
        {locationFlag && (
          <AddNewLocation
            open={locationFlag}
            handleClose={locatClose}
            id={id}
            locationRowDetailValue={locationRowDetail}
          />
        )}
        {brokerFlag && (
          <AddEditBroker
            open={brokerFlag}
            handleClose={brokerClose}
            id={id}
            brokerRowDetailValue={brokerRowDetail}
            locationList={locationList}
            projectDetailValue={details && details[0]}
          />
        )}
        {removeModel && (
          <RemoveConfirmationProjectBroker
            open={removeModel}
            removeItem={removeItem}
            removeItemFuncConfirm={removeItemFuncConfirm}
          />
        )}

        {removeModelLocation && (
          <RemoveConfirmationProjectLocation
            open={removeModelLocation}
            removeItem={removeItem}
            removeItemFuncConfirm={removeItemLocationFuncConfirm}
          />
        )}
      </Box>
    </>
  );
};

export default ProjectDetails;
